import React from "react";
import Typed from "react-typed";
import { Link } from "react-scroll";
import { SiGooglescholar } from "react-icons/si";

function Herosection(props) {
  const { x, y } = props.position;
  const { height, width } = props.elementDimensions;
  const activeParallax = (depth = 15) => {
    let posX = (width / 2 - x) / depth;
    let posY = (height / 2 - y) / depth;
    return {
      transform: `translate(${posX}px, ${posY}px)`,
    };
  };

  return (
    <section
      id="home"
      className={
        props.light
          ? "home d-flex align-items-center light"
          : "home d-flex align-items-center"
      }
    >
      <div className="container">
        <div className="intro">
          <img width="250px" height="250px" src="images/avatar.png" alt="Salim" className="mb-4" />

          <h1 className="mb-2 mt-0">Salim I. Amoukou</h1>
          <p>
            {/*I'm {" "}*/}
            <Typed
              strings={[
                "",
                "P.h.D. in Statistics a̶n̶d̶ or Machine Learning",
                "AI Research Scientist at JP Morgan",
                "Passionate about the Philosophy of Science",
              ]}
              typeSpeed={40}
              backSpeed={20}
              attr="value"
              loop
            >
              <label value></label>
            </Typed>
          </p>

          <ul className="social-icons light list-inline mb-0 mt-4">
            <li className="list-inline-item">
              <a href="https://www.linkedin.com/in/slim-amk/">
                <i className="fab fa-linkedin"></i>
              </a>
            </li>
            <li className="list-inline-item">
              <a href="https://twitter.com/salim_amk0">
                <i className="fab fa-twitter"></i>
              </a>
            </li>
              <li className="list-inline-item">
              <a href="https://scholar.google.com/citations?user=YOUR_ID&user=JrHnICMAAAAJ">
                 <SiGooglescholar size={24} />
              </a>
            </li>
          </ul>

          <div className="mt-4">
            <Link
              className="btn btn-default"
              to="section-contact"
              spy={true}
              smooth={true}
              duration={500}
            >
              Contact Me
            </Link>
          </div>
        </div>

        <div className="scroll-down">
          <Link
            to="section-about"
            spy={true}
            smooth={true}
            duration={500}
            className="mouse-wrapper"
          >
            <span>Scroll Down</span>
            <span className="mouse">
              <span className="wheel"></span>
            </span>
          </Link>
        </div>

        <div className="parallax" data-relative-input="true">
          {/* p1: Integral symbol */}
          <svg
            width="27"
            height="29"
            className="layer p1"
            xmlns="http://www.w3.org/2000/svg"
            style={activeParallax(15)}
          >
            <text
              x="3"
              y="24"
              fontSize="28"
              fontFamily="serif"
              fill="#FFD15C"
              fontStyle="italic"
            >
              ∫
            </text>
          </svg>

          {/* p2: Expectation E */}
          <svg
            width="26"
            height="26"
            className="layer p2"
            xmlns="http://www.w3.org/2000/svg"
            style={activeParallax(20)}
          >
            <text
              x="2"
              y="22"
              fontSize="26"
              fontFamily="serif"
              fill="#FF4C60"
              fontWeight="bold"
              fontStyle="italic"
            >
              𝔼
            </text>
          </svg>

          {/* p3: Gaussian curve */}
          <svg
            width="30"
            height="25"
            className="layer p3"
            xmlns="http://www.w3.org/2000/svg"
            style={activeParallax(25)}
          >
            <path
              d="M2 22 Q7 12, 15 8 T28 22"
              stroke="#44D7B6"
              strokeWidth="2.5"
              fill="none"
              strokeLinecap="round"
            />
          </svg>

          {/* p4: Random walk */}
          <svg
            width="30"
            height="30"
            className="layer p4"
            xmlns="http://www.w3.org/2000/svg"
            style={activeParallax(10)}
          >
            <path
              d="M5 25 L10 20 L15 23 L20 15 L25 19"
              stroke="#FFD15C"
              strokeWidth="2.5"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          {/* p5: Nabla (gradient) */}
          <svg
            width="22"
            height="23"
            className="layer p5"
            xmlns="http://www.w3.org/2000/svg"
            style={activeParallax(8)}
          >
            <text
              x="0"
              y="20"
              fontSize="24"
              fontFamily="serif"
              fill="#6C6CE5"
              fontWeight="bold"
            >
              ∇
            </text>
          </svg>

          {/* p6: Neural network nodes */}
          <svg
            width="49"
            height="30"
            className="layer p6"
            xmlns="http://www.w3.org/2000/svg"
            style={activeParallax(18)}
          >
            <g fill="#FF4C60">
              <circle cx="8" cy="8" r="3" />
              <circle cx="8" cy="22" r="3" />
              <circle cx="25" cy="15" r="3" />
              <circle cx="41" cy="8" r="3" />
              <circle cx="41" cy="22" r="3" />
            </g>
            <g stroke="#FF4C60" strokeWidth="1.5" fill="none" opacity="0.6">
              <line x1="11" y1="8" x2="22" y2="15" />
              <line x1="11" y1="22" x2="22" y2="15" />
              <line x1="28" y1="15" x2="38" y2="8" />
              <line x1="28" y1="15" x2="38" y2="22" />
            </g>
          </svg>

          {/* p7: Delta symbol */}
          <svg
            width="26"
            height="26"
            className="layer p7"
            xmlns="http://www.w3.org/2000/svg"
            style={activeParallax(22)}
          >
            <text
              x="2"
              y="22"
              fontSize="24"
              fontFamily="serif"
              fill="#FFD15C"
              fontWeight="bold"
            >
              Δ
            </text>
          </svg>

          {/* p8: Theta parameter */}
          <svg
            width="22"
            height="24"
            className="layer p8"
            xmlns="http://www.w3.org/2000/svg"
            style={activeParallax(15)}
          >
            <text
              x="2"
              y="20"
              fontSize="24"
              fontFamily="serif"
              fill="#6C6CE5"
              fontStyle="italic"
            >
              θ
            </text>
          </svg>

          {/* p9: Sigma summation */}
          <svg
            width="26"
            height="28"
            className="layer p9"
            xmlns="http://www.w3.org/2000/svg"
            style={activeParallax(10)}
          >
            <text
              x="2"
              y="24"
              fontSize="28"
              fontFamily="serif"
              fill="#6C6CE5"
              fontWeight="bold"
            >
              Σ
            </text>
          </svg>

          {/* p10: Lambda eigenvalue */}
          <svg
            width="24"
            height="29"
            className="layer p10"
            xmlns="http://www.w3.org/2000/svg"
            style={activeParallax(23)}
          >
            <text
              x="2"
              y="24"
              fontSize="26"
              fontFamily="serif"
              fill="#44D7B6"
              fontStyle="italic"
            >
              λ
            </text>
          </svg>
          {/* p12: Partial derivative */}
          <svg
            width="24"
            height="28"
            className="layer p12"
            xmlns="http://www.w3.org/2000/svg"
            style={activeParallax(18)}
          >
            <text
              x="2"
              y="24"
              fontSize="26"
              fontFamily="serif"
              fill="#FFD15C"
              fontStyle="italic"
            >
              ∂
            </text>
          </svg>
        </div>
      </div>
    </section>
  );
}

export default Herosection;